import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const markAllNotificationsRead = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${__API_URL__}/api/staff-notifications/mark-all-read/`,
    {},
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

const useMarkAllNotificationsReadMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markAllNotificationsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["staff-notifications"] });
      queryClient.invalidateQueries({ queryKey: ["staff-notifications-unread-count"] });
    },
  });
};

export default useMarkAllNotificationsReadMutation;
